export default __webpack_public_path__ + "static/media/heb-logo.75982276.png";